export const TILE_TEXT = 'Change Your Program Role'
